<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  props: {
    labels: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      options: {
        legend: { display: true },
        title: {
          display: false,
        },
        scales: {
          xAxes: [{
            barThickness: 40,
            maxBarThickness: 30,
          }],
        },
      },
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
      };
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
